<template>
<v-container class="hideReply">
    <v-layout row wrap>
        <v-flex xs9>
            <v-list-tile-content class="hideMessage" data-qe-id="hidden-reply_hidden-message">
                {{communityCommonConstant.post.HIDE_REPLY}}
            </v-list-tile-content>
        </v-flex>
        <v-flex xs3 text-xs-right>
            <v-btn id="undo_unitTest" class="primary_btn transparent" flat @click="unHideReplies" data-qe-id="hidden-reply_unhide_btn">
                {{communityCommonConstant.post.UNDO}}
            </v-btn>
        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
    import { communityCommonConstant } from '../communityCommon.constant';
    import { mapActions } from "vuex";
    import { storeAction } from '@/store/storeActions.constant';

    export default {
        name: 'HiddenReply',
        data: () => ({
            communityCommonConstant,
        }),
        props: {
            reply: {
                type: Object,
                required: true,
            },
        },
        methods: {
            ...mapActions('chapter', [
                storeAction.unHidePost,
            ]),
            unHideReplies() {
                this.unHidePost(this.reply.id);
            },
        },
        computed: {
            ownerName() {
                return `${this.comment.authorFirstName} ${this.comment.authorLastName}`;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../../common/styles/_colors.scss';
    @import '../../../common/styles/_responsive.scss';

.hideReply {
  background: rgba($ypo-title-border, 0.3);
  border: 1px solid rgba($ypo-title-border, 0.6);
  border-radius: 4px;
  margin: 10px 10px 10px 10px;
  padding: 5px 0 5px 0;
  font-size: 12px;
  width: auto;
   @include breakpoint(xs) {
       padding-right: 20px;
   }
  
  .hideMessage{
    color: $black;
    font-family: "Noto Sans";
    font-size: 14px;
    margin-left: 20px;
  }
}

</style>
